import * as UAParser from "ua-parser-js";

export function getUserDeviceInfo() {
  //@ts-ignore
  const parser = new UAParser.UAParser();
  const ua = parser.getResult();
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  
  return {
    deviceType: ua.device.type ?? "desktop",
    deviceModel: ua.device.model ?? "",
    deviceVendor: ua.device.vendor ?? "",

    // Browser info
    browserName: ua.browser.name ?? "",
    browserVersion: ua.browser.version ?? "",

    // OS info
    osName: ua.os.name ?? "",
    osVersion: ua.os.version ?? "",

    // Screen info
    screenWidth: window.screen?.width,
    screenHeight: window.screen?.height,
    pixelRatio: window.devicePixelRatio,

    // Hardware info
    cpuThreads: navigator.hardwareConcurrency,
    memoryGB: navigator.deviceMemory,

    // User environment
    languages: navigator.languages,
    timezone: timeZone,

    // Touch support
    touchSupport: "ontouchstart" in window,

    // Origin
    origin: window.location.origin,
    requestOrigin: window.location.origin,

    // Raw UA
    userAgent: navigator.userAgent
};
}


